/* eslint-disable react/jsx-props-no-spreading, react/no-unstable-nested-components, react/prop-types */
import { useEffect, useState } from 'react'
import EATable from 'Components/UI/EATable'

import EAReportTableSummary from './Summary'

import appendColumnPropertiesByType from './utils/appendColumnPropertiesByType'

const EAReportTable = ({
  columns = [],
  dataSource = [],
  ...antdTableProps
}) => {
  const [data, setData] = useState(dataSource)

  useEffect(() => {
    setData(dataSource || [])
  }, [dataSource])

  const processedColumns = columns.map((column) =>
    appendColumnPropertiesByType(column)
  )

  return (
    <EATable
      bordered
      columns={processedColumns}
      dataSource={dataSource}
      onChange={(pagination, filters, sorter, extra) => {
        setData(extra.currentDataSource || [])
      }}
      summary={() => (
        <EAReportTableSummary columns={processedColumns} dataSource={data} />
      )}
      {...antdTableProps}
    />
  )
}

export default EAReportTable
